import { createSelector } from '@reduxjs/toolkit';

const makeBidAskBySymbolSelector = () =>
  createSelector(
    (state) => state.bidask,
    (_, symbol) => symbol,
    (bidask, symbol) => {
      return bidask?.bidask[symbol] ?? null;
    }
  );

const makeSymbolBySymbolNameSelector = () =>
  createSelector(
    (state) => state.symbol.instruments,
    (_, symbol) => symbol,
    (instruments, symbol) => {
      return instruments.find((e) => e.symbol === symbol);
    }
  );

const makeSymbolKeySelector = () =>
  createSelector(
    (state) => state,
    (_) => null,
    (state) => {
      const positionSymbols = new Set(state.positions?.positions?.map(pos => pos.symbol) || []);
      return state.symbol.instruments.reduce((a, b) => {
        const isInPositions = positionSymbols.has(b.symbol);
        return {
          ...a,
          [b.symbol]: {
            type: b.calc_mode === 0 ? 'forex' : 'cfd',
            contract_size: b.contract_size,
            tick_size: b.tick_size,
            base: b.currency_base,
            quote: b.currency_profit,
            digits: b.digit,
            currency_profit_digits: b.currency_profit_digits,
            hasPosition: isInPositions,
            profit_rate: isInPositions ? state.positions.positions.find(pos => pos.symbol === b.symbol).rateProfit : 1
          }
        };
      }, {});
    }
  );

const makeBidAskSelector = () =>
  createSelector(
    (state) => state,
    (_, isBid) => isBid,
    (state, isBid) => {
      return state.bidask?.bidask[state.symbol.active]?.[isBid] ?? 0;
    }
  );

  const makeAllTickSelector = () =>
    createSelector(
      (state) => state,
      (_) => null,
      (state) => {
        return state.bidask?.bidask ?? null;
      }
    );

const makeTradeDialogSelector = () =>
  createSelector(
    (state) => state.tradeDialog,
    (_) => null,
    (tradeDialog) => {
      return tradeDialog;
    }
  );

const makeMenuSelector = () =>
  createSelector(
    (state) => state.symbol,
    (_) => null,
    ({ menu }) => ({ menu })
  );

const makePictureSelector = () =>
  createSelector(
    (state) => state.symbol.instruments,
    (_, id) => id,
    (instruments, id) => {
      return instruments.reduce(
        (a, b) => ({
          ...a,
          [b.symbol]: b.logo
        }),
        {}
      );
    }
  );

const makeOrderSelector = () =>
  createSelector(
    (state) => state.orders?.orders,
    (_) => null,
    (orders) => orders
  );

const makePositionNoReduceSelector = () =>
  createSelector(
    (state) => state,
    (_, symbol) => symbol,
    (state, symbol) => {
      const positions = state?.positions?.positions;
      const symbolData = state?.symbol?.instruments;
      // console.log('positions')
      return (
        positions.map((e) => {
          return {
            ...e,
            calcMode: symbolData.find((s) => s.symbol === e.symbol)?.calc_mode
          };
        }) ?? []
      );
    }
  );

const makePositionSelector = () =>
  createSelector(
    (state) => state.positions?.positions,
    (_, symbol) => symbol,
    (positions) => {
      let position = [];
      positions.forEach((element) => {
        position.push({
          position: element[0],
          symbol: element[1],
          action: element[2] ?? 0,
          digits: element[3],
          digitsCurrency: element[4],
          contractSize: element[5],
          timeCreate: element[6],
          timeUpdate: element[7],
          priceOpen: element[8],
          priceCurrent: element[9],
          priceSL: element[10] ?? 0,
          priceTP: element[11] ?? 0,
          volume: element[12],
          profit: element[13] ?? 0,
          reason: element[14]
        });
      });
      return position;
    }
  );

const makeStatSelector = () =>
  createSelector(
    (state) => state.stat,
    (_, symbolArr) => symbolArr,
    (stat, symbolArr) => {
      // console.log(stat)
      // console.log('open', open)
      // console.log(stat);
      // console.log(first)
      // const fil = stat?.filter((item) => symbol.includes(item.symbol));
      // const t = tick?.filter((item) => symbol.includes(item.symbol));
      // const ba = t.reduce((a, b) => ({ ...a, [b.symbol]: b }), {});
      // return fil.reduce(
      //   (a, b) => ({
      //     ...a,
      //     [b.symbol]: {
      //       ...b,
      //       bid: ba[b.symbol].bid,
      //       ask: ba[b.symbol].ask
      //     }
      //   }),
      //   {}
      // );
    }
  );

const makeInstrumentInfoSelector = () =>
  createSelector(
    (state) => state.symbol.instruments,
    (_, symbolArr) => symbolArr,
    (instruments, symbolArr) => {
      return instruments.filter((e) => e.symbol === symbolArr)[0] ?? null;
    }
  );

const makeInstrumentByIdSelector = () =>
  createSelector(
    (state) => state.symbol.instruments,
    (_, id) => id,
    (instruments, id) => {
      return instruments.find((e) => e.symbol === id);
    }
  );

export {
  makeBidAskBySymbolSelector,
  makeTradeDialogSelector,
  makeMenuSelector,
  makePictureSelector,
  makePositionSelector,
  makeStatSelector,
  makeInstrumentByIdSelector,
  makeBidAskSelector,
  makeOrderSelector,
  makePositionNoReduceSelector,
  makeInstrumentInfoSelector,
  makeSymbolBySymbolNameSelector,
  makeSymbolKeySelector,
  makeAllTickSelector
};
